
// src/actions/diary-form.js

export const INSERT_DIARY_FORM = "INSERT_DIARY_FORM"
export const CLEAR_INSERT_DIARY_FORM = "CLEAR_INSERT_DIARY_FORM"

export function insertDiaryForm(html) {
  return {
    type: INSERT_DIARY_FORM,
    html,
  }
}

export function clearInsertDiaryForm() {
  return {
    type: CLEAR_INSERT_DIARY_FORM,
  }
}



// WEBPACK FOOTER //
// ./src/actions/diary-form.js